import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

export function getCombinedFilterSizeData(data) {
  var sizeObject = {
    field: 'size',
    label: 'Size',
    nestedFilters: [],
    totalAggregationCount: 0
  }; // if we already have a size filter field, skip this extra logic

  if (data.some(filterField => filterField.field === 'size')) {
    return data;
  }

  var firstSizeIndex = data.findIndex(filterField => filterField.field.startsWith('size_')); // Handle case where there are no size filters.

  if (firstSizeIndex === -1) {
    return data;
  }

  var transformedData = [];
  data.forEach(filterField => {
    if (filterField.field.startsWith('size_')) {
      sizeObject.nestedFilters.push(filterField);
      sizeObject.totalAggregationCount += filterField.totalAggregationCount;
    } else {
      transformedData.push(filterField);
    }
  });
  transformedData.splice(firstSizeIndex, 0, sizeObject);
  return transformedData;
}
export function getSizesFromAggregationFilter(aggregationFilters, currentSizes) {
  // Create a copy of `currentSizes` so we aren't modifying the reference.
  var selectedSizes = currentSizes ? _objectSpread({}, currentSizes) : {};
  Object.entries(aggregationFilters).forEach(_ref => {
    var _ref2 = _slicedToArray(_ref, 2),
        field = _ref2[0],
        value = _ref2[1];

    if (field.startsWith('size')) {
      if (Array.isArray(value) && value.length >= 1) {
        selectedSizes[field] = value;
      } else {
        delete selectedSizes[field];
      }
    }
  });

  if (Object.keys(selectedSizes).length === 0) {
    return undefined;
  }

  return selectedSizes;
}
export function getActiveSizes(profileSizes, sessionSizes) {
  var activeSizes = {};
  var sharedSizes = [];

  if (profileSizes) {
    Object.entries(profileSizes).forEach(_ref3 => {
      var _ref4 = _slicedToArray(_ref3, 2),
          field = _ref4[0],
          value = _ref4[1];

      // Attempt to use the session size
      if (sessionSizes !== null && sessionSizes !== void 0 && sessionSizes[field]) {
        sharedSizes.push(field);
      } else {
        // When there is no matching `field` in `sessionSizes` use the profile size
        // Use the first profile size if this is an array
        if (value) {
          activeSizes[field] = Array.isArray(value) ? value[0] : value;
        }
      }
    });
  }

  if (sessionSizes) {
    Object.entries(sessionSizes).forEach(_ref5 => {
      var _ref6 = _slicedToArray(_ref5, 2),
          field = _ref6[0],
          value = _ref6[1];

      if (!sharedSizes.includes(field)) {
        var size = Array.isArray(value) ? value[0] : value;
        activeSizes[field] = size;
      } else {
        if (Array.isArray(value)) {
          // When there is only a singular `sessionSize`, set that to the session size
          if (value.length === 1) {
            activeSizes[field] = value[0];
          } else {
            // When there are multiple `sessionSize` values, fall back to the profile size
            activeSizes[field] = Array.isArray(profileSizes[field]) ? profileSizes[field][0] : profileSizes[field];
          }
        } else if (typeof value === 'string') {
          activeSizes[field] = value;
        }
      }
    });
  }

  return activeSizes;
}
export function parseBraSize(braSize) {
  var _braSize$match = braSize.match(/[a-z]+|[^a-z]+/gi),
      _braSize$match2 = _slicedToArray(_braSize$match, 2),
      bandSize = _braSize$match2[0],
      cupSize = _braSize$match2[1]; // for cases such as "S" or "L", we don't want to return undefined on the cupSize


  return [bandSize, cupSize || ''];
}
export function parseBraSizes(braSizes) {
  return braSizes.reduce((cupSizesByBand, braSize) => {
    var _parseBraSize = parseBraSize(braSize),
        _parseBraSize2 = _slicedToArray(_parseBraSize, 2),
        bandSize = _parseBraSize2[0],
        cupSize = _parseBraSize2[1];

    var prevCupSizes = cupSizesByBand[bandSize] || [];
    cupSizesByBand[bandSize] = [...prevCupSizes, cupSize];
    return cupSizesByBand;
  }, {});
}
export function isStandardSelectorVariation() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return /regular|normal|normaal|standard|estándar/gi.test(value);
}